import { render, staticRenderFns } from "./JobPostingForm.vue?vue&type=template&id=06c6dacc&scoped=true"
import script from "./JobPostingForm.vue?vue&type=script&lang=js"
export * from "./JobPostingForm.vue?vue&type=script&lang=js"
import style0 from "./JobPostingForm.vue?vue&type=style&index=0&id=06c6dacc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c6dacc",
  null
  
)

export default component.exports